/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsHospital from './HospitalsHospital';

/**
 * The SurgeonsBody model module.
 * @module model/SurgeonsBody
 * @version v0.3
 */
export default class SurgeonsBody {
  /**
   * Constructs a new <code>SurgeonsBody</code>.
   * @alias module:model/SurgeonsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurgeonsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurgeonsBody} obj Optional instance to populate.
   * @return {module:model/SurgeonsBody} The populated <code>SurgeonsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurgeonsBody();
      if (data.hasOwnProperty('surgeon'))
        obj.surgeon = HospitalsHospital.constructFromObject(data['surgeon']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsHospital} surgeon
 */
SurgeonsBody.prototype.surgeon = undefined;

